import React from 'react';
import { Row, Col, Image } from '@thd-olt-component-react/core-ui';
import { EXP_ROUTES } from '../../../utils/constants';
import PageHeader from '../../common/PageHeader/PageHeader';
import { generateImageSource } from '../../../utils/generateImageSource';
import GoBackNavLink from '../../common/GoBackNavLink';

export const CompanyProfileHeader = () => {
  const backToObj = {
    backTo: 'Job Postings',
    backToUrl: EXP_ROUTES.JOB_POSTINGS
  };

  return (
    <>
      <PageHeader>Path to Pro Network</PageHeader>
      <Row>
        <Col xs={12}>
          <GoBackNavLink backToStr={backToObj.backTo} fallbackUrl={backToObj.backToUrl} />
          <div className="ptp-job-template__title">
            <Image
              data-testid="jobTemplateIcon"
              alt="document icon"
              src={generateImageSource('/images/v1/path-to-pro/company-profile-icon.svg')}
              style={{ width: '30px', height: '30px' }}
              className="ptp-job-template__title-icon"
            />
            Company Profile
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={8} fallback={12}>
          <p className="ptp-company-profile__header-text">
            Your company profile will be shown to job candidates and applicants on all your job
            postings. You will still be able to edit this information for each job posting you
            create, and change it across all postings.
          </p>
        </Col>
      </Row>
    </>
  );
};
